import React from 'react';
import styled from 'styled-components';
import parse from 'html-react-parser';
import classnames from 'classnames';
import ButtonToolbar from 'react-bootstrap/ButtonToolbar';
import DropdownButton from 'react-bootstrap/DropdownButton';
import Dropdown from 'react-bootstrap/Dropdown';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';

const StyledContainer = styled.div`
    a.dropdown-item.disabled {
        color: ${({ theme }) => theme.gray5} !important;
        font-weight: normal !important;
    }
`;
// Hooks

import { useLocation } from '@hooks/useLocation';

const NavBar = props => {

    const {
        houseIcon,
        menu
    } = props;

    const { currentLocation } = useLocation();

    const getSubMenus = (subMenus) => {
        return subMenus.map((subItem) => {

            const {
                caption,
                disableMenu,
                reactLink,
                url,
                visibleMenu
            } = subItem;
            const submenuTestId = subItem.dataTestId;

            const disabledItemClass = classnames({ 'cursor-not-allowed pointer-events-all disabled ': disableMenu });

            if(!visibleMenu) {
                return null;
            }

            if (reactLink) {
                return (
                    <Dropdown.Item
                        as={Link}
                        to={disableMenu ? '/#' : url}
                        id={caption}
                        key={caption}
                        disabled={disableMenu}
                        className={disabledItemClass}
                        data-testid={submenuTestId}
                    >
                        {caption}
                    </Dropdown.Item>
                );
            }

            return (
                <Dropdown.Item
                    href={disableMenu ? undefined : url}
                    key = { caption }
                    disabled = { disableMenu }
                    className = { disabledItemClass }
                    data-testid={submenuTestId}
                >
                    {parse(caption)}
                </Dropdown.Item>
            );
        });
    };

    const getMenu = () => {
        return menu.map((item) => {
            const { caption, subMenus, url } = item;
            const areSubMenus = Array.isArray(subMenus) && subMenus.length > 0;

            const isDropdownButtonActive = subMenus.some(sm => sm.url === currentLocation);

            const variant = classnames(
                caption,
                { 'active': isDropdownButtonActive }
            );

            return areSubMenus
                ? (
                    <DropdownButton
                        title = { parse(caption) }
                        variant = { variant }
                        id = { `dropdown-variants-${ caption }` }
                        key = { caption }
                        data-testid={item.dataTestId}
                    >
                        { getSubMenus(subMenus) }
                    </DropdownButton>
                )
                : (
                    <a
                        className = 'navbar__simple-link'
                        href = { url }
                        key = { caption }
                        data-testid={item.dataTestId}
                    >
                        { parse(caption) }
                        { houseIcon && <FontAwesomeIcon icon='home' className='ml-2' /> }
                    </a>
                );
        });
    };

    return(
        <StyledContainer className = 'navbar'>
            <ButtonToolbar className = 'navbar__toolbar'>
                { getMenu() }
            </ButtonToolbar>
        </StyledContainer>
    );
};

export default NavBar;